import styles from "./styles.module.scss";
import { FC } from "react";
import { Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import CaseDossier from "components/CaseDossier";
import casesService from "api/casesService";
import Button from "components/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DossierFolderModal: FC<Props> = ({
  folderId,
  caseId,
  toggle,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: Case } = casesService.useGetCase(caseId);

  const navigateToCase = () => {
    navigate(`/cases/${caseId}/dossier/f/${folderId}`);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {t("menu.folder")}
        <CloseIcon onClick={() => toggle(false)} className={styles.closeIcon} />
      </div>
      <div className={styles.content}>
        {Case && <CaseDossier Case={Case} folderId={folderId}></CaseDossier>}
        <div className={styles.absoluteButtons}>
          <Button text={t("cases.goToCase")} onClick={navigateToCase}></Button>
        </div>
      </div>
    </div>
  );
};

export default DossierFolderModal;
